import './LandingFindMyPlan.scss';
import '../../Landing.scss';

import { ButtonV2, Icon } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import { useAnalytics } from '../../../../analytics';
import headerPresentationImage from '../../../../assets/find-my-plan.svg';
import { Link } from '../../../../components/Link';

const className = 'c-LandingFindMyPlan';

export const LandingFindMyPlan = () => {
  const { t } = useTranslation();
  const analyticsContext = useAnalytics();

  const handleTryItOutClick = () => {
    const trackingData = {
      element_id: 'btn_findmyplan_engagement',
      element_text: 'Try it out',
    };

    analyticsContext?.trackClickAction(trackingData);
  };

  return (
    <article className={className}>
      <div className={`${className}__image-container`}>
        <img
          src={headerPresentationImage}
          width="423"
          height="404"
          loading="lazy"
          role="presentation"
        />
      </div>

      <div className={`${className}__content`}>
        <header className={`${className}__header`}>
          <h3 className={`${className}__header-title`}>
            {t('landing.find_my_plan.title', 'Find My Plan')}
          </h3>
        </header>
        <div className={`${className}__text-description`}>
          <ul className={`${className}__text-description-list`}>
            <li>
              <Icon name="check" />
              {t(
                'landing.find_my_plan.description.first',
                'Pinpoint the perfect eSIM plan in seconds!',
              )}
            </li>
            <li>
              <Icon name="check" />
              {t(
                'landing.find_my_plan.description.second',
                'Personalised recommendations for your trip.',
              )}
            </li>
            <li>
              <Icon name="check" />
              {t(
                'landing.find_my_plan.description.third',
                'An even faster way to escape roaming charges...',
              )}
            </li>
          </ul>
        </div>
        <div className={`flex ${className}__text-button`}>
          <ButtonV2
            asChild
            size="large"
            variant="primary"
            fluid
            intent="support-violet"
            onClick={handleTryItOutClick}
            data-testid="button-find-my-plan"
          >
            <Link to="/find-my-plan">
              {t('landing.find_my_plan.button', 'Try it out')}
            </Link>
          </ButtonV2>
        </div>
      </div>
    </article>
  );
};
